import { useEffect, useState } from 'react';
import { fetchCollegeVideos } from '../services/api';
import { hydrationVideosSeed, prerenderState } from '../seo/prerenderState';

// The Watch section's videos for one college page (#4608). The first render
// is the build's: at build time the list the prerender read, in the browser
// the seed the page's HTML carries (so hydration matches). After mount the
// live list replaces it, so a Short that went live since the build shows
// without a deploy. A failed read keeps what the page has; a page that never
// had any renders nothing.
function initialVideos(slug) {
    const pre = prerenderState();
    if (pre) {
        const list = slug && pre.collegeVideos ? pre.collegeVideos[slug] || null : null;
        pre.videos = Array.isArray(list) && list.length ? list : null;
        return pre.videos;
    }
    return hydrationVideosSeed();
}

export default function useCollegeVideos(slug) {
    const [state, setState] = useState(() => ({ slug, videos: initialVideos(slug) }));
    useEffect(() => {
        if (!slug) return undefined;
        let alive = true;
        fetchCollegeVideos(slug).then((colleges) => {
            if (!alive || colleges === null) return;
            setState({ slug, videos: Array.isArray(colleges[slug]) ? colleges[slug] : [] });
        });
        return () => { alive = false; };
    }, [slug]);
    // Similar schools links keep this page mounted: one school's videos never
    // sit on another's page while its own read is on the way.
    return state.slug === slug ? state.videos : null;
}
